<!--
 * @Author: LiuMeiYu
 * @Date: 2023-02-01 17:23:08
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-02-09 16:43:49
 * @FilePath: \CardSwap\src\views\demand\createDemandView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="createdemand-container">
    <div class="createdemand-content">
      <div class="createdemand-step-box">
        <div class="createdemand-step-title">My requirement</div>
        <div class="step-rules">
          You are buying USA Steam Gift Card. According to each transaction, you
          will pay 1% of order amount to CardSwap.
        </div>
        <el-button
          class="btn-createdemand-step"
          @click="createDemandNextRef.open()"
          >Next</el-button
        >
        <el-button class="btn-createdemand-cancel" @click="$router.back()"
          >Back</el-button
        >
      </div>
      <div class="createdemand-result-box">
        <div class="createdemand-title">
          Create My Requirement
        </div>
        <div class="step-one-content">
          <div class="step-content">
            <div class="step-item active">
              <div class="step-state-icon">
                <el-image
                  :src="
                    require('../../assets/images/agreement_register_phone_active.png')
                  "
                />
              </div>
              Card Type
            </div>
            <div class="step-line">— — — — — — —</div>
            <div class="step-item">
              <div class="step-state-icon">
                <el-image
                  :src="
                    require('../../assets/images/agreement_register_phone.png')
                  "
                />
              </div>
              Set My Price
            </div>
            <div class="step-line">— — — — — — —</div>
            <div class="step-item">
              <div class="step-state-icon">
                <el-image
                  :src="
                    require('../../assets/images/agreement_register_phone.png')
                  "
                />
              </div>
              Other Settings
            </div>
          </div>
          <div class="go-to-do">
            <p>What are you going to do？</p>
            <div class="buy-gift-card">
              <el-image :src="require('../../assets/images/gou.png')" />
              Buy Gift card (Your offer will be dispayed in 'BUY'. ）
            </div>
          </div>
          <el-form
            class="create-demand-form"
            :model="createDemandFormData"
            label-position="top"
          >
            <el-form-item label="Gift Card Type">
              <el-select v-model="createDemandFormData.cardType" size="large">
                <el-option
                  v-for="item in createDemandFormData.cardTypeListData"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="Currency">
              <el-select v-model="createDemandFormData.currency" size="large">
                <el-option
                  v-for="item in createDemandFormData.currencyListData"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <Popup ref="createDemandNextRef">
      <template #content>
        <div class="caretedemand-next-content">
          <el-icon :size="80" :color="'#2d43bf'"><InfoFilled /></el-icon>
          <div class="title">Not enough permissions</div>
          <div class="desc">
            Only verified traders have right to purchase. Please verify ID
            before purchasing
          </div>
          <el-button @click="createDemandNextRef.close()">OK</el-button>
        </div>
      </template>
    </Popup>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "@vue/runtime-core";
import { getDemandListApi } from "../../api/index";
import bus from "../../utils/eventBus";
import Popup from "../../components/popupView.vue";
import { InfoFilled } from "@element-plus/icons-vue";

export default defineComponent({
  name: "DemandeList",
  components: { Popup },
  setup() {
    onMounted(() => {
      bus.emit("changeTitle", "All Offers");
      getcreatedemand();
    });
    const createDemandNextRef = ref(null);
    const state = reactive({
      createDemandFormData: {
        cardType: "",
        currency: "",
        cardTypeListData: [],
        currencyListData: [],
      },
    });
    // 获取需求列表 里面有所有卡类型
    const getcreatedemand = () => {
      let data = {};
      // 获取需求列表
      getDemandListApi(data).then((res) => {
        console.log("getcreatedemandApi：", res);
        if (res.data.success) {
          if (res.data.data.category_list.length > 0) {
            state.createDemandFormData.cardTypeListData =
              res.data.data.category_list;
            state.createDemandFormData.cardType =
              res.data.data.category_list[0];
          }
          if (res.data.data.currency_list.length > 0) {
            state.createDemandFormData.currencyListData =
              res.data.data.currency_list;
            state.createDemandFormData.currency =
              res.data.data.currency_list[0];
          }
        }
      });
    };
    return {
      InfoFilled,
      createDemandNextRef,
      ...toRefs(state),
    };
  },
});
</script>
<style lang="less" scoped>
.createdemand-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  background-color: #f7f7f7;
  .createdemand-content {
    display: flex;
    .createdemand-step-box {
      max-width: 217px;
      padding: 20px;
      border-radius: 12px 12px 12px 12px;
      background-color: #ffffff;
      .createdemand-step-title {
        padding-bottom: 20px;
        text-align: left;
        font-size: 16px;
        color: #000000;
        font-weight: bold;
        border-bottom: 1px solid #dfdfdf;
      }
      .step-rules {
        margin-top: 20px;
        padding: 20px;
        background-color: #fafafa;
        border-radius: 12px;
        color: #03004d;
        text-align: left;
        border: 1px dashed #dfdfdf;
        font-size: 14px;
      }
      .btn-createdemand-step {
        margin-top: 20px;
        border-radius: 12px;
        background-color: #03004d;
        color: #ffffff;
      }
      .btn-createdemand-cancel {
        margin-top: 20px;
        border-color: #efefef;
        border-radius: 12px;
        color: #03004d !important;
        background-color: #efefef;
      }
    }
    .createdemand-result-box {
      min-width: 1018px;
      padding: 20px;
      margin-left: 10px;
      border-radius: 12px 12px 12px 12px;
      background-color: #ffffff;
      .createdemand-title {
        text-align: left;
        font-weight: bold;
        font-size: 22px;
      }
      .step-one-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .step-content {
          margin-top: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          .step-line {
            padding: 0 20px;
            color: #8f94a2;
          }
          .step-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #999999;
            .step-state-icon {
              .el-image {
                width: 20px;
                height: 20px;
                margin-bottom: 10px;
              }
              .step-unfinish {
                width: 20px;
                height: 20px;
                margin-bottom: 10px;
                background-color: #f5f7f8;
                border-radius: 50%;
              }
            }
            &.active {
              color: #000000;
            }
          }
        }
        .go-to-do {
          width: 524px;
          min-width: 524px;
          margin-top: 40px;
          padding: 20px;
          background-color: #2d43bf;
          border-radius: 10px;
          color: #ffffff;
          text-align: left;
          p {
            margin-bottom: 20px;
            font-size: 18px;
          }
          .buy-gift-card {
            display: flex;
            align-items: center;
            .el-image {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }
          }
        }
        .create-demand-form {
          margin-top: 20px;
          .el-select {
            width: 564px;
            min-width: 524px;
          }
          :deep(.el-input__inner) {
            border-radius: 12px;
          }
          :deep(.el-form-item) {
            margin-bottom: 10px;
          }
          :deep(.el-form-item__label) {
            padding: 0;
            color: #000000;
            font-weight: bold;
          }
        }
      }
    }
  }
  .caretedemand-next-content {
    padding: 20px;
    .title {
      margin: 20px 0;
      font-size: 24px;
      color: #2d43bf;
    }
    .desc {
      margin: 20px 0;
      color: #b5bec8;
    }
    .el-button {
      margin-top: 40px;
      color: #ffffff;
      background-color: #03004d;
      border-radius: 12px;
    }
  }
}
</style>
